import { render, staticRenderFns } from "./UIModalContent.vue?vue&type=template&id=3b718cb9"
import script from "./UIModalContent.vue?vue&type=script&lang=js"
export * from "./UIModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports